<script>
  import { slide, fade } from 'svelte/transition'
  import Icon from './Icon.svelte';

  export let onClose
  export let title = ''

  const clickedBackDrop = event => {
    if (event.target == event.currentTarget ) {
      onClose(event)
    }
  }
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  class="popup-box-bg"
  on:click={e => clickedBackDrop(e)}
  transition:fade|local
>
  <div class="white-box-popup network-bar-pop-up-modal" transition:slide|local>
    {#if title}
      <div class="header-popup">
        <h3>{title}</h3>
        <div on:click={(e) => onClose(e)}><Icon icon="close" /></div>
      </div>
    {/if}

    <div class="popup-middle-text">
      <slot />
    </div>
  </div>
</div>

<style lang="scss">

  @media (max-width: 500px) {
    .network-bar-pop-up-modal {
      width: 325px!important;
    }
  }
  @media (min-width: 501px) {
    .network-bar-pop-up-modal {
      margin-top: -100px!important;
    }
  }
  .popup-box-bg {
    background: rgba(23, 23, 23, 0.3);
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    .white-box-popup {
      background: #FFFFFF;
      border-radius: 12px;
      width: 100%;
      max-width: 400px;
      margin: 0 auto;
      .header-popup {
        display: flex;
        justify-content: space-between;
        width: 100%;
        padding: 16px 24px;
        border-bottom: 1px solid #EEEEEE;
        align-items: center;
      }
      .header-popup h3 {
        color: #474B50;
        font-weight: 700;
        font-size: 20px;
        margin: 0;
      }
      .popup-middle-text{
        padding: 24px;
        width: 100%;
      }
      .popup-middle-text p{
        color: #616C74;
        font-weight: 500;
        font-size: 16px;
      }
    }
  }
</style>

